import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type EnumGetListRequest = GetListRequest<EnumGetListRequestFilter>;
export type EnumGetListResponse = GetListResponse<Enum>;
export type EnumDeleteRequest = DeleteRequest;
export type EnumItemGetListResponse = GetListResponse<EnumItem>;

export const lookupCodes = ['enum'] as const;

export type LookupCode = typeof lookupCodes[number];

export interface Lookup {
  id: number;
  name: string;
  code: LookupCode;
  description: string;
  isActive: boolean;
}

export interface EnumGetListRequestFilter {
  name?: string | null;
}

export interface Enum {
  /** @format int64 */
  id?: number;

  /** @format byte */
  system_RowVersion?: string | null;
  name?: string | null;
}

export interface EnumItem {
  /** @format int32 */
  value?: number;
  name?: string | null;
  id?: number;
  system_RowVersion?: string;
}

export interface EnumEnumTranslationInsertRequest {
  /** @format int32 */
  value: number;
  translation: string;
  name: string;

  /** @format int64 */
  refLanguage_Id: number;
  enumName?: string | null;
}

export interface EnumInsertRequest {
  name: string;
  enum_Translations: EnumEnumTranslationInsertRequest[];
}

export interface LookupType {
  ClassificationLookUp: number,
  GroupLookUp: number,
  TypeLookUp: number,
  Category1LookUp: number,
  Category2LookUp: number,
  StatusLookUp: number,
  ParticipationTypeLookUp: number,
  OrganizationLookUp: number,
  CommitteeLookUp: number,
  MeetingLookUp: number,
  TeamLookUp: number,
  ConfidentialityLookUp: number,
  AuthenticationToolLookUp: number
}
